/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  Card,
  Grid,
  CardActionArea,
  CircularProgress,
} from '@material-ui/core';
import { Circle } from 'rc-progress';
import { connect } from 'react-redux';
import { Check, Close } from '@material-ui/icons';
import config from '../../../config';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
  },
  actionArea: {
    width: '100%',
    height: '100%',
  },
  title: {
    padding: '1em',
    paddingTop: '0px',
    textAlign: 'center',
    fontSize: '20px',
  },
  subtitle: {
    fontSize: '17px',
    fontStyle: 'italic',
  },
  center: {
    margin: 'auto',
  },
  circleContainer: {
    padding: '20px',
  },
  fullWidth: {
    width: '100%',
    maxWidth: '100%',
  },
  percentageText: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '100%',
  },
});

const TotalProgressWidget = ({
  data, darkMode, loadingResults,
}) => {
  const classes = useStyles();
  const [goal, setGoal] = useState(null);
  // const [isCompleted, setIsCompleted] = useState(false);
  const [totalProgress, setTotalProgress] = useState(-1);
  const colorPrimary = darkMode ? config.darkColor : config.primaryColor;

  useEffect(() => {
    if (data !== undefined && data.length > 0) {
      let total = 0;
      let quizPercent = 0;
      data[0].forEach((module) => {
        module.units.forEach((unit) => {
          const isScored = unit.unit.isFinalQuiz === true || unit.unit.isRise === true;
          if (!isScored) return;

          total += 1;

          const sc = unit.result?.score;

          if (sc) {
            // scaled (0..1) prioritaire si présent
            const hasScaled = sc.scaled !== undefined && sc.scaled !== null && Number(sc.scaled) !== 0;
            const p = hasScaled
              ? Number(sc.scaled) * 100
              : (sc.raw != null && sc.max != null && Number(sc.max) > 0)
                ? (Number(sc.raw) / Number(sc.max)) * 100
                : null;

            if (p != null && Number.isFinite(p)) {
              quizPercent += p;
              return;
            }
          }

          // fallback si vraiment pas de score
          if (unit.result?.completion && unit.result?.success) {
            quizPercent += 100;
          }
        });
      });
      quizPercent /= total;
      setTotalProgress(Math.floor(quizPercent));
      setGoal(data[1].elearningTarget);
    }
  }, [data]);

  return (
    <Card direction="row" className={classes.root}>
      {!loadingResults ? (
        <CardActionArea
          component={Link}
          className={classes.actionArea}
          to={{
            pathname: '/elearning/results',
          }}
        >
          <Grid className={classes.actionArea} container direction="row" alignItems="center" alignContent="center">
            <Grid container item xs={6} md={6} direction="column" alignItems="center" alignContent="center">
              <Grid className={classes.fullWidth} item xs={4} md={4}>
                <Typography variant="h5" component="h3" className={classes.title} aria-label="Total Quizzes Progress">
                  Success rate
                </Typography>
              </Grid>
              <Grid item xs={4} md={4} className={classes.percentageText}>
                { totalProgress > -1
                  ? (
                    <Typography variant="h3" className={`${classes.center} ${classes.percentage}`}>
                      {`${Math.trunc(totalProgress)} %`}
                    </Typography>
                  )
                  : (
                    <Typography variant="h6" className={`${classes.center} ${classes.percentage}`}>
                      Loading..
                    </Typography>
                  )}
              </Grid>
              <Grid
                className={classes.fullWidth}
                item
                xs={4}
                md={4}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '1em',
                  gap: '10px',
                }}
              >
                <Typography
                  component="h4"
                  variant="body1"
                  className={classes.subtitle}
                  style={{
                    color: darkMode ? '#b9b9b9e9' : '#4F4F4F',
                    padding: '0px',
                    margin: '0px',
                  }}
                >
                  {goal !== null && goal >= 0 ? `Objective : ${goal}%` : 'Loading..'}
                </Typography>
                {totalProgress >= goal
                  ? (
                    <Check
                      style={{
                        padding: '0px',
                        margin: '0px',
                        color: '#62D562',
                      }}
                    />
                  )
                  : (
                    <Close
                      color="secondary"
                      style={{
                        padding: '0px',
                        margin: '0px',
                      }}
                    />
                  )}
              </Grid>
            </Grid>
            <Grid className={classes.circleContainer} item xs={6} md={6}>
              <Circle
                percent={totalProgress || 0}
                strokeWidth="9"
                trailWidth="9"
                strokeColor={totalProgress >= goal ? '#66DD66' : colorPrimary}
                style={{ width: '100%' }}
              />
            </Grid>
          </Grid>
        </CardActionArea>
      )
        : (
          <div
            style={{
              height: '200px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </div>
        )}
    </Card>
  );
};

TotalProgressWidget.propTypes = {
  data: PropTypes.array.isRequired,
  darkMode: PropTypes.bool.isRequired,
  loadingResults: PropTypes.bool.isRequired,
};

function mapState(state) {
  const { darkMode } = state.ui;
  return {
    darkMode,
  };
}
export default connect(mapState, null)(TotalProgressWidget);
